export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageAlerts.vue?vue&type=template&id=baf7ce7e&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/ManageAlerts.vue?vue&type=template&id=baf7ce7e&
// module id = null
// module chunks = 